import NumberFormat from "react-number-format";
import HandleLang from "./handleLang";

const formatNumber = (number, decimals) => {
  if (HandleLang('en')) {
    return (
      <NumberFormat
        value={parseFloat(number)}
        thousandSeparator=","
        decimalSeparator="."
        decimalScale={parseInt(decimals)}
        displayType="text"
        fixedDecimalScale={true}
      />
    )
  } else {
    return (
      <NumberFormat
        value={parseFloat(number)}
        thousandSeparator=" "
        decimalSeparator=","
        decimalScale={parseInt(decimals)}
        displayType="text"
        fixedDecimalScale={true}
      />
    )
  }
}

export default formatNumber
